<template>
  <div class="overview-tab">
    <filter-bar @set-searching-term="setNewSearchingTerm"></filter-bar>
    <div class="content">
      <report-empty-state
        v-if="!hasSearchingGrade"
        :title="$t('score_report.student.empty_state_title')"
        :desc="$t('score_report.student.empty_state_desc')"
      ></report-empty-state>
      <template v-else>
        <information-block ref="ifmBlock"></information-block>
        <students-table ref="stdTable"></students-table>
      </template>
    </div>
  </div>
</template>

<script>
import FilterBar from "./FilterBar.vue";
import InformationBlock from "./Information.vue";
import StudentsTable from "./StudentsTable.vue";
import ReportEmptyState from "@/pages/Report/Components/EmptyState.vue";
import { service_paths } from "@/constants/Services";
import { initLoader, Message } from "@/helpers/utils";

export default {
  components: { FilterBar, InformationBlock, StudentsTable, ReportEmptyState },
  data() {
    return {
      path: service_paths.reports,
      // fields just have value after click search button
      reportParams: {
        searchingTerm: null,
        searchingGrade: null
      }
    };
  },
  computed: {
    hasSearchingGrade() {
      return !!this.reportParams.searchingGrade;
    }
  },
  methods: {
    setNewSearchingTerm(term) {
      this.$set(this.reportParams, "searchingTerm", term);
    },
    setNewSearchingParams(paramObj) {
      paramObj &&
        Object.keys(this.reportParams).forEach(field => {
          this.$set(this.reportParams, field, paramObj[field]);
        });
    },

    fetchReport(newSearchingParams) {
      const { searchingGrade, searchingTerm } = newSearchingParams;

      if (!searchingGrade) {
        Message.error("Please choose at least 1 grade");
        return;
      }

      const loader = initLoader();
      // ? centralize fetch report data when change searching term.

      const baseQueryObj = {
        grade_id: searchingGrade.id,
        term_id: searchingTerm?.id
      };

      this.setNewSearchingParams(newSearchingParams);

      // fetch report after view updated
      this.$nextTick(() => {
        Promise.all([
          this.$refs.ifmBlock.fetchReportOverview(baseQueryObj),
          this.$refs.stdTable.fetchTopGPAs(false)
        ])
          .then(() => {})
          .finally(() => {
            loader.hide();
          });
      });
    }
  },
  provide() {
    return {
      reportParams: this.reportParams,
      basePath: this.path,
      fetchReport: this.fetchReport
    };
  }
};
</script>

<style lang="scss" scoped></style>
